import Raven from 'raven-js';
const VisibleListTypes = new Set(['ENROLLMENT_LIST', 'RE_ENROLLMENT_LIST', 'PERSISTED_RE_ENROLLMENT_LIST', 'CLASSIC_GOAL_LIST', 'SUPPRESSION_LIST', 'ADDED_TO_LIST_TRIGGER', 'REMOVED_FROM_LIST_TRIGGER']);
const InternalDirectListReferences = new Set(['ENROLLMENT_LIST', 'RE_ENROLLMENT_LIST', 'PERSISTED_RE_ENROLLMENT_LIST', 'CLASSIC_GOAL_LIST', 'SUPPRESSION_LIST']);
const getFirstMatchingListType = itemData => {
  const firstMatchingListType = itemData.listTypes.find(listType => VisibleListTypes.has(listType));
  if (!firstMatchingListType) {
    // If there's a list type we don't intentionally want to display on the FE, hide it
    console.error('Found LIST_MEMBERSHIP_WITH_VISIBILITY timeline item with UNKNOWN reference type: ', itemData);
    Raven.captureMessage('Found LIST_MEMBERSHIP_WITH_VISIBILITY timeline item with UNKNOWN reference type', {
      extra: {
        itemData
      }
    });
  }
  return firstMatchingListType;
};
export const isInternalListTimelineItem = ({
  data: itemData
}) => {
  if (itemData.referenceType === 'UNKNOWN') {
    // Hide UNKNOWN lists for now, since this ideally shoudn't happen
    console.error('Found LIST_MEMBERSHIP_WITH_VISIBILITY timeline item with UNKNOWN reference type: ', itemData);
    Raven.captureMessage('Found LIST_MEMBERSHIP_WITH_VISIBILITY timeline item with UNKNOWN reference type', {
      extra: {
        itemData
      }
    });
    return true;
  }
  const firstMatchingListType = getFirstMatchingListType(itemData);
  return !firstMatchingListType || itemData.referenceType === 'DIRECT' && InternalDirectListReferences.has(firstMatchingListType);
};
export const getInternalListDisplayNameKey = item => {
  const firstMatchingListType = getFirstMatchingListType(item.data);
  const {
    changeStatus
  } = item.data.objectListMembership;
  if (firstMatchingListType && InternalDirectListReferences.has(firstMatchingListType)) {
    return `flow-doctor-lib.flows.objectLifecycle.listMembershipHistory.label.internal.${firstMatchingListType}_${changeStatus}_jsx`;
  }
  return `flow-doctor-lib.flows.objectLifecycle.listMembershipHistory.label.internal.fallback.${changeStatus}_jsx`;
};